module.exports = __webpack_public_path__ + "static/media/dta.1229d798.svg";